import moment from 'moment';
import { YearMonthDay } from '@interfaces/graphql-typings';

export const formatDate = ({ month, day, year }: YearMonthDay): string => {
  const formattedMonth = moment()
    .month(month - 1)
    .format('MMMM');

  return formattedMonth + ' ' + day + ', ' + year;
};
